import apiFetch from './client';

export interface MeResponse {
  id: string;
  firebaseUid: string;
  email: string;
  firstName?: string;
  lastName?: string;
  documentNumber?: string;
  phone?: string;
  photoUrl?: string;
  lastSelectedTenantSlug?: string;
  isGlobalAdmin?: boolean;
  isCondominiumManager?: boolean;
  createdAt: string;
  lastLoginAt?: string;
  updatedAt: string;
}

export const getMe = () => apiFetch<MeResponse>('/accounts/me');

export const updateMe = (data: Partial<MeResponse>) =>
  apiFetch<MeResponse>('/accounts/me', {
    method: 'PUT',
    body: JSON.stringify(data),
  });
